/* SiteSelectorPermissionErrorSection.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { AppInstallPermission } from '@atlassian/mpac-services-client';
import React from 'react';
import SiteSelectorError from './SiteSelectorError';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}";
const siteSelectorErrorSectionStyles = null;
const SiteSelectorPermissionErrorSection = props => {
  const {
    installPermission,
    isFreeApp,
    appHasMultiInstanceLicense,
    supportsTwoStepInstallation
  } = props;
  const {
    enableMILCustomerSupport,
    enableAppificationChanges
  } = useStatsig();
  if (installPermission === AppInstallPermission.CAN_INSTALL_FREE_AND_PAID) {
    if (enableMILCustomerSupport() && appHasMultiInstanceLicense) {
      return /*#__PURE__*/_jsx(SiteSelectorError.AppHasMultiInstanceLicenseExists, {});
    }
    return null;
  } else if (installPermission === AppInstallPermission.CANNOT_INSTALL) {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_]
      }), /*#__PURE__*/_jsx("div", {
        className: ax([supportsTwoStepInstallation && "_19pkpxbi"]),
        children: /*#__PURE__*/_jsx(SiteSelectorError.CannotInstallAnyApps, {
          enableAppificationChanges: enableAppificationChanges()
        })
      })]
    });
  } else if (installPermission === AppInstallPermission.CAN_INSTALL_FREE_ONLY) {
    return isFreeApp ? null : /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_]
      }), /*#__PURE__*/_jsx("div", {
        className: ax([supportsTwoStepInstallation && "_19pkpxbi"]),
        children: /*#__PURE__*/_jsx(SiteSelectorError.CannotInstallPaidApps, {})
      })]
    });
  } else {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_]
      }), /*#__PURE__*/_jsx("div", {
        className: ax([supportsTwoStepInstallation && "_19pkpxbi"]),
        children: /*#__PURE__*/_jsx(SiteSelectorError.Unknown, {})
      })]
    });
  }
};
export default SiteSelectorPermissionErrorSection;